export enum ServiceEntryStatuses {
    Unconfirmed = 1,
    Confirmed = 2,
    Voided = 3
}